import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CTASection from '../components/sections/CTASection';
import SocialProof from '../components/sections/SocialProof';

const msItems = [
  'tematické bloky a aktivity',
  'komunikace s rodiči',
  'příprava podkladů',
  'tvorba materiálů',
];

const zsItems = [
  'přípravy hodin',
  'pracovní listy',
  'testy a otázky',
  'diferenciace výuky',
  'slovní hodnocení',
  'administrativní texty',
];

const ssItems = [
  'jak zadávat práci tak, aby ji AI nevyřešila místo žáka',
  'jak hodnotit výstupy vytvořené s pomocí AI',
  'jak pracovat s AI při přípravě maturitních podkladů',
];

function SchoolCard({ label, color, intro, items, note }) {
  const dotColor = color === 'teal' ? '#0d9488' : color === 'blue' ? '#0369a1' : '#7c3aed';
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-8">
      <div className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase mb-5 ${
        color === 'teal' ? 'bg-teal-50 text-teal-700 border border-teal-200'
        : color === 'blue' ? 'bg-blue-50 text-blue-700 border border-blue-200'
        : 'bg-violet-50 text-violet-700 border border-violet-200'
      }`}>
        {label}
      </div>
      {intro && <p className="text-slate-600 mb-5 leading-relaxed">{intro}</p>}
      <ul className="space-y-3">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-3">
            <div className="w-2 h-2 rounded-full flex-shrink-0 mt-2" style={{ background: dotColor }} />
            <span className="text-slate-700">{item}</span>
          </li>
        ))}
      </ul>
      {note && <p className="mt-5 text-sm text-slate-500 border-t border-slate-100 pt-4">{note}</p>}
    </div>
  );
}

export default function TypySkolPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>

        {/* Hero */}
        <section className="pt-36 pb-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="inline-flex items-center px-4 py-2 bg-teal-50 border border-teal-100 rounded-full text-teal-700 text-sm font-medium mb-8">
              Financovatelné z OP JAK II
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 leading-tight mb-8">
              Pro jaké školy školení realizujeme
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed max-w-2xl">
              Obsah školení vždy přizpůsobujeme <strong className="text-slate-900">typu školy</strong>.
            </p>
          </div>
        </section>

        {/* Školy */}
        <section className="py-16 bg-slate-50 border-t border-slate-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-3 gap-6">
              <SchoolCard
                label="Mateřské školy"
                color="teal"
                intro="AI zde funguje jako praktický pomocník při tvorbě obsahu."
                items={msItems}
              />
              <SchoolCard
                label="Základní školy"
                color="blue"
                items={zsItems}
                note="Součástí je také práce s tématem AI u žáků."
              />
              <SchoolCard
                label="Střední školy"
                color="violet"
                intro="Na středních školách se často řeší jiné otázky:"
                items={ssItems}
                note="AI zde slouží jako nástroj — ne jako téma."
              />
            </div>
          </div>
        </section>

        <SocialProof />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
